import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;
// Async thunk to apply a coupon
export const applyCoupon = createAsyncThunk(
  "coupon/applyCoupon",
  async ({ code, cartTotal }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${BASE_URL}/api/coupon/apply-coupon`, { code, cartTotal }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    discount: 0,
    newTotal: 0,
    loading: false,
    error: null,
    message: null,
    couponCode: null,
  },
  reducers: {
    clearCoupon: (state) => {
      state.discount = 0;
      state.newTotal = 0;
      state.error = null;
      state.message = null;
      state.couponCode = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(applyCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
        state.couponCode = null;
      })
      .addCase(applyCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.discount = action.payload.discount;
        state.newTotal = action.payload.newTotal;
        state.error = action.payload.message;
        state.message = action.payload.message;
        state.couponCode = action.payload.code
      })
      .addCase(applyCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        state.message = action.payload.message;
        state.couponCode = action.payload.code
      });
  },
});

export const { clearCoupon } = couponSlice.actions;
export default couponSlice.reducer;
